import { Download } from "lucide-react";
import { getDesktopDownloadUrl } from "../lib/desktop-download";

/**
 * Shown on the production site (Account). Uses `VITE_DESKTOP_DOWNLOAD_URL` or GitHub Releases fallback.
 * Does not affect the Tauri app (updater still uses `tauri.conf.json`).
 */
export function DesktopDownloadCard() {
  const url = getDesktopDownloadUrl();
  if (!url) return null;

  return (
    <div className="hidden rounded-xl border border-border bg-surface-1/80 p-5 backdrop-blur-sm md:block">
      <div className="flex items-start gap-3">
        <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-surface-2">
          <Download className="h-5 w-5 text-accent" aria-hidden />
        </div>
        <div className="min-w-0">
          <h2 className="font-display text-base font-semibold text-text">Windows desktop app</h2>
          <a
            href={url}
            rel="noopener noreferrer"
            className="mt-3 inline-flex items-center gap-2 rounded-xl bg-accent px-4 py-2.5 text-sm font-semibold text-surface-0 shadow-lg shadow-accent/25 hover:brightness-110"
          >
            <Download className="h-4 w-4" aria-hidden />
            Download installer
          </a>
        </div>
      </div>
    </div>
  );
}
